module.exports = __webpack_public_path__ + "static/img/honor_4.6bfe7ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/honor_4.jpg
// module id = enUs
// module chunks = 0